module.exports = __webpack_public_path__ + "static/agency-banner-95fa98c51452192450f0bee53ab1dd09.png";